import React from "react";
import { Layout } from "@/components/Layout";
import { ReportsPanel } from "@/components/Reports";
import { useLanguage } from "@/lib/i18n";

/**
 * Reports Page
 * 
 * This page serves as the primary interface for financial analysis within the football betting system.
 * It leverages the ReportsPanel to provide hierarchical win/lose data, date-based filtering,
 * and match-specific breakdowns for Company, Agent, and Player tiers.
 * 
 * Current Year: 2026
 */
const Reports: React.FC = () => {
  const {
    t
  } = useLanguage();
  return <Layout>
      <div className="flex-1 w-full space-y-8 p-6 lg:p-10 animate-in fade-in slide-in-from-bottom-4 duration-700 text-[13px] lg:text-base">
        {/* Header Section */}
        

        {/* Main Reporting Interface */}
        <div className="space-y-4">
          <ReportsPanel />
        </div>

        {/* Footer info/Disclaimer for the demo */}
        
      </div>
    </Layout>;
};
export default Reports;